import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import CapsuleUICircle from "@/images/crm-software/capsule-ui-circle.svg"
import OverlappingPills from "@/images/misc/overlapping-pills.svg"

export const InlineCTAUI = ({ text, link, linkText }) => {
  const { t } = useTranslation()

  text = text ?? t("common.try-capsule-free-14-days")
  link = link ?? "/signup/"
  linkText = linkText ?? t("common.get-started")

  return (
    <div className="inline-cta inline-cta--ui mb-8">
      <img src={CapsuleUICircle} alt="" />

      <div className="inline-cta--ui__text">
        <span
          className="text-white h4 text-balance"
          style={{
            marginBottom: 0,
            fontWeight: 500,
          }}
        >
          {text}
        </span>

        <Link
          className="btn inline-cta__link btn--secondary btn--sm mt-4"
          to={link}
        >
          {linkText}
        </Link>
      </div>
    </div>
  )
}

export const InlineCTAGraphic = ({ text, link, linkText }) => {
  const { t } = useTranslation()

  text = text ?? t("common.try-capsule-free-14-days")
  link = link ?? "/signup/"
  linkText = linkText ?? t("common.get-started")

  return (
    <div className="inline-cta inline-cta--graphic mb-8">
      <div className="inline-cta--graphic__text">
        <span
          className="text-white h4 text-balance"
          style={{
            marginBottom: 0,
            fontWeight: 500,
          }}
        >
          {text}
        </span>

        <Link
          className="btn inline-cta__link mt-4 btn--secondary btn--sm"
          to={link}
        >
          {linkText}
        </Link>
      </div>

      <img src={OverlappingPills} alt="" />
    </div>
  )
}

export const InlineCTA = ({ text, link, linkText }) => {
  const { t } = useTranslation()

  text = text ?? t("common.try-capsule-free-14-days")
  link = link ?? "/signup/"
  linkText = linkText ?? t("common.get-started")

  return (
    <div className="inline-cta inline-cta--base mb-8">
      <span className="text-bold text-white text-balance">{text}</span>

      <Link className="btn inline-cta__link btn--secondary btn--sm" to={link}>
        {linkText}
      </Link>
    </div>
  )
}

export default InlineCTA
